import { t } from "@lingui/macro";
import { InvoiceTypeEnum } from "@src/components/modules/invoices/Create/store";
import { dateTime } from "@src/utils/formatters";
import type React from "react";
import type { FC } from "react";
import { useStore } from "../../../store";
import type { ColumnProps } from ".";
import { EditDateWrapper } from "./edit-date-wrapper";

export const PaidAt: FC<React.PropsWithChildren<ColumnProps>> = ({ row }) => {
  const { paid, paid_at } = row;
  const store = useStore();

  return (
    <EditDateWrapper
      dataComponentName="paid-at-edit-date-trigger"
      isDisabled={!paid_at}
      row={row}
      invoiceType={InvoiceTypeEnum.Proforma}
      onUpdate={store.proformaInvoicesRefetch}
      modalStore={store.changeDatesModalStore}
    >
      {paid_at
        ? dateTime.format(new Date(paid_at))
        : !!paid && paid !== 0
          ? t`Partially paid`
          : t`Unpaid`}
    </EditDateWrapper>
  );
};
